
import { httpService } from "./utils/http_service";
import type {
    AtsWebhookTestRequest,
    AtsWebhookTestResponse,
    Company,
    CompanyInfo,
    CompanyWebserviceKey,
    WebserviceEndpointInfo,
    WorkflowWebhookTestRequest,
    WorkflowWebhookTestResponse
} from "@/interfaces/company";

export const companyService = {

    getInfo(nickname?: string): Promise<CompanyInfo> {
        return httpService.get(`/public/company/`, {
            skipLoading: true,
            params: nickname ? { vc_apelido: nickname } : undefined
        });
    },

    get(): Promise<Company> {
        return httpService.get(`/company/`, { skipLoading: true });
    },

    update(company: Company | {}): Promise<Company> {
        return httpService.put(`/company/`, company);
    },

    generateApikey(): Promise<string> {
        return httpService.patch(`/company/webservice/apikey/`, null);
    },

    getWebserviceEndpoints(): Promise<WebserviceEndpointInfo[]> {
        return httpService.get(`/company/webservice/endpoints`);
    },

    listWebserviceKeys(): Promise<CompanyWebserviceKey[]> {
        return httpService.get(`/company/webservice/keys`);
    },

    createWebserviceKey(data: { vc_descricao: string; ar_endpoints: string[] }): Promise<CompanyWebserviceKey> {
        return httpService.post(`/company/webservice/keys`, data);
    },

    updateWebserviceKey(id: string, data: { vc_descricao: string; ar_endpoints: string[] }): Promise<CompanyWebserviceKey> {
        return httpService.put(`/company/webservice/keys/${id}`, data);
    },

    deleteWebserviceKey(id: string): Promise<void> {
        return httpService.delete(`/company/webservice/keys/${id}`);
    },

    testAtsWebhook(data: AtsWebhookTestRequest): Promise<AtsWebhookTestResponse> {
        return httpService.post(`/company/ats-webhook/test`, data);
    },

    testWorkflowWebhook(data: WorkflowWebhookTestRequest): Promise<WorkflowWebhookTestResponse> {
        return httpService.post(`/company/workflow-webhook/test`, data);
    },
}
